// extracted by mini-css-extract-plugin
export default {"root":"AddressCard_root__4a0iL","add":"AddressCard_add__DNvxA"};